/** **************************** Import Types ****************************** */
import {
   NEWSFEED_REQUEST,
   NEWSFEED_SUCCESS,
   NEWSFEED_FAILURE,
  } from "../types/newsfeed.types";
  
  const initialState = {
    storeItemResponse: "",
    error: "",
    loading: false,
  };
  
  const NewsfeedReducer = (state = initialState, action) => {
    switch (action.type) {
      case NEWSFEED_REQUEST:
        return {
          ...state,
  
          loading: true,
        };
      case NEWSFEED_SUCCESS:
        return {
          ...state,
          storeItemResponse: action.payload,
          loading: false,
        };
      case NEWSFEED_FAILURE:
        return {
          ...state,
          error: action.payload,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default NewsfeedReducer;
  